import { Navigate, useLocation } from "react-router-dom";

export default function AuthRoute({ children }) {
  const token = localStorage.getItem("token");
  const location = useLocation();
  if (location.pathname === "/oauth-success") {
    return children;
  }
  return token ? <Navigate to="/dashboard" replace /> : children;
}
